var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"no-pod-session-pill"},[_c('span',{staticClass:"t3 -t_medium"},[_vm._v(_vm._s(_vm.$t('NO_POD_SESSION.AVAILABLE')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }